"use client";

import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import apiClient from "@/lib/api";

interface PracticeLimitState {
  remaining: number | null;
  limit: number | null;
  unlimited: boolean;
  loading: boolean;
  showModal: boolean;
}

export function usePracticeLimit(): PracticeLimitState {
  const { user, loading: authLoading } = useAuth();
  const [remaining, setRemaining] = useState<number | null>(null);
  const [limit, setLimit] = useState<number | null>(null);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (authLoading || user) return;

    let cancelled = false;

    apiClient
      .get("/answers/remaining")
      .then((res) => {
        if (cancelled) return;
        const data = res.data;
        if (!data.unlimited) {
          setRemaining(data.remaining);
          setLimit(data.limit);
        }
      })
      .catch(() => {
        // fail open: エラー時は制限なしとして扱う
      })
      .finally(() => {
        if (!cancelled) setFetched(true);
      });

    return () => {
      cancelled = true;
    };
  }, [user, authLoading]);

  const unlimited = !!user;
  const loading = authLoading || (!unlimited && !fetched);
  const showModal = !unlimited && !loading && remaining === 0;

  return { remaining, limit, unlimited, loading, showModal };
}
